import React, { useContext, useEffect, useMemo, useState } from 'react'
import {
  BusinessPageBecomeBusinessButton,
  BusinessPageInfo,
  BusinessPagePrimaryWidgetBackground,
  BusinessPagePrimaryWidgetItemsContainer,
  BusinessPageSubtitle,
  BusinessPageTitleH1,
  BusinessPageTitleH2,
  BusinessPublicPageContent,
  BusinessPublicPageLayout,
} from './BusinessPublicPageStyles'
import {
  MentorJoinModalContent,
  MentorOnboardingFormComponent,
  StyledDialogActions,
  StyledDialogJoinButton,
  StyledDialogPaper,
  StyledDialogSingleAction,
  StyledDialogTitle,
  StyledDialogVerifiedButton,
  StyledEmailNotVerifiedMessage,
  StyledMentorEmailInputAndMessageContainer,
  StyledMentorJoinVerifyLink,
  StyledMentorJoinVerifyLinkAfter,
} from 'src/mentor/components/MentorPublicPage/MentorPublicPageStyledComponents'
import {
  CustomCheckBox,
  CustomInput,
  CustomSelect,
  selectTypes,
} from 'src/consumer/components/helperComponents'
import { SEOComponent, validateEmail } from 'src/consumer/helpers/utilFunctions'
import { APP_CONSTANTS } from 'src/consumer/constants'
import PublicAppHeader from 'src/consumer/components/PublicAppHeader'
import { getImageLink, isBasicOnboardingDone } from 'src/mentor/helpers/utilityFunctions'
import { InfoWithHeadingDescriptionAndImage } from 'src/consumer/components/ListingPageComponentsAndHelpers/ListingPageComponents'
import { getAllRolesInBoolean } from 'src/mentor/layout/utils'
import { useNavigate } from 'react-router-dom'
import { UnsecureSetupContext } from 'src/consumer/context/UnsecureSetupContext'
import { Dialog } from '@mui/material'
import { getMPDataWithoutParams, postMPDataWithoutParams } from 'src/mentor/services'
import { postDataWithoutParams } from 'src/consumer/services/featureServices'
import { PublicAppFooter } from 'src/consumer/components/PublicAppFooter'

export default function BusinessPublicPage({ blankPage }) {
  const { unSecureSetupData } = useContext(UnsecureSetupContext)
  const [showJoinForm, setShowJoinForm] = useState(blankPage ? true : false)
  const [formState, setFormState] = useState({})
  const [profileData, setProfileData] = useState()
  const navigate = useNavigate()
  const token = localStorage.getItem('token')
  const availableRoles = getAllRolesInBoolean()

  function handleChange(event) {
    if (event.target.type === 'checkbox') {
      setFormState((prev) => ({ ...prev, [event.target.id]: event.target.checked }))
    } else {
      setFormState((prev) => ({ ...prev, [event.target.id]: event.target.value }))
    }
  }

  function handleJoinBusiness() {
    if (token && isBasicOnboardingDone(profileData)) {
      handleOpenForm()
    } else if (token && !isBasicOnboardingDone(profileData)) {
      navigate('/onboarding', {
        state: {
          redirectAfterLogin: true,
          redirectAfterRegistration: true,
          redirectAfterOnboarding: false,
          redirectTo: '/aumhum-for-workplace/apply',
          redirectData: {
            mustHaveDoneBasicOnboarding: true,
            prospectiveBusinessCustomer: true,
          },
        },
      })
    } else {
      navigate('/onboarding', {
        state: {
          redirectAfterLogin: true,
          redirectAfterRegistration: true,
          redirectAfterOnboarding: false,
          redirectTo: '/aumhum-for-workplace/apply',
          redirectData: {
            mustHaveDoneBasicOnboarding: true,
            prospectiveBusinessCustomer: true,
          },
        },
      })
    }
  }

  function handleOpenForm() {
    if (availableRoles?.isBusinessCustomer || availableRoles?.isBusinessProspect) {
      navigate('/workplace')
    } else {
      setShowJoinForm(true)
    }
  }

  function handleClose() {
    if (blankPage) {
    } else {
      setShowJoinForm(false)
    }
  }

  async function getProfileData(setEmailNotVerifiedShow) {
    const resp = await getMPDataWithoutParams('/api/secure/user/profile')
    if (resp?.status === 200) {
      const profileData = resp.data
      setProfileData(profileData)
      console.log(unSecureSetupData)
      const locationCountryCode = localStorage.getItem('countryCode') || 'in'
      const foundCountry = unSecureSetupData?.metaCountries.find(
        (country) => country.id === locationCountryCode.toLowerCase(),
      )
      setEmailNotVerifiedShow && !resp?.data?.emailVerified && setEmailNotVerifiedShow(true)
      setEmailNotVerifiedShow && resp?.data?.emailVerified && setEmailNotVerifiedShow(false)
      setFormState((prev) => {
        console.log(prev)
        console.log(resp?.data?.email)
        return {
          ...prev,
          email: prev?.email || resp?.data?.email || '',
          firstName: prev?.firstName || resp?.data?.firstName || '',
          location: {
            country:
              prev?.location?.country ||
              resp?.data?.location?.country ||
              foundCountry?.title ||
              foundCountry?.name ||
              '',
            countryCode:
              prev?.location?.countryCode ||
              resp?.data?.location?.countryCode ||
              foundCountry?.id ||
              '',
          },
        }
      })
    }
  }

  async function Setup() {
    await Promise.all([getProfileData()])
  }

  async function handleSubmit(event) {
    const form = event.currentTarget
    if (form.checkValidity() === false) {
      event.preventDefault()
      event.stopPropagation()
    } else {
      event.preventDefault()
      const { terms, ...toSubmit } = formState
      const response = await postDataWithoutParams('/api/secure/bp/new', toSubmit)
      if (response.status === 200) {
        const role = localStorage.getItem('authorities')
        const role_array = JSON.parse(role)
        localStorage.setItem(
          'authorities',
          JSON.stringify([...role_array, 'ROLE_BUSINESS_PROSPECT']),
        )
        // above line is not needed now as business profile context whenever opens will update the local storage
        navigate('/workplace')
      }
    }
  }

  useEffect(() => {
    Setup()
  }, [])

  useEffect(() => {
    if (blankPage && (availableRoles?.isBusinessCustomer || availableRoles?.isBusinessProspect)) {
      navigate('/workplace')
    }
  }, [])

  // public page and redirection:
  function goToLogin() {
    navigate('/login', {
      state: {
        redirectAfterLogin: true,
        redirectAfterRegistration: true,
        redirectAfterOnboarding: false,
        redirectTo: '/aumhum-for-workplace/apply',
        redirectData: {
          mustHaveDoneBasicOnboarding: true,
          prospectiveBusinessCustomer: true,
        },
      },
    })
  }
  function goToRegister() {
    navigate('/onboarding', {
      state: {
        redirectAfterLogin: true,
        redirectAfterRegistration: true,
        redirectAfterOnboarding: false,
        redirectTo: '/aumhum-for-workplace/apply',
        redirectData: {
          mustHaveDoneBasicOnboarding: true,
          prospectiveBusinessCustomer: true,
        },
      },
    })
  }

  return (
    <>
      <PublicAppHeader loginFunction={goToLogin} registerFunction={goToRegister} />
      <SEOComponent
        title="Mental Wellbeing for Businesses | AUMHUM"
        description="Give your employees access to wide array of self-care resources and mental health
                services."
        image={APP_CONSTANTS.APP_LOGO_LINK}
        keywordsArr={['workspace', 'businesses', 'employees']}
      />

      {blankPage ? (
        <></>
      ) : (
        <BusinessPublicPageLayout>
          <BusinessPagePrimaryWidgetItemsContainer>
            <BusinessPublicPageContent>
              <BusinessPageSubtitle>For Businesses</BusinessPageSubtitle>
              <BusinessPageTitleH1>Support your team&apos;s</BusinessPageTitleH1>
              <BusinessPageTitleH2>Mental Health</BusinessPageTitleH2>
              <BusinessPageInfo>
                Give your employees access to wide array of self-care resources and mental health
                services.
              </BusinessPageInfo>
              <BusinessPageBecomeBusinessButton onClick={handleJoinBusiness}>
                {availableRoles.isBusinessCustomer || availableRoles.isBusinessProspect
                  ? 'Go to Workplace Dashboard'
                  : 'Get Started'}
              </BusinessPageBecomeBusinessButton>
            </BusinessPublicPageContent>
            <BusinessPagePrimaryWidgetBackground
              src={getImageLink(APP_CONSTANTS.BUSINESS_PUBLIC_PAGE_IMAGE_ID)}
              alt="background"
            />
          </BusinessPagePrimaryWidgetItemsContainer>
          <InfoWithHeadingDescriptionAndImage
            headline="Empower Your Workplace"
            description="Elevate your workplace with mental health solutions for your employees. Explore our plans and offerings designed to boost their well-being."
            image={getImageLink(APP_CONSTANTS.BUSINESS_PUBLIC_PAGE_TEAM_IMAGE)}
          />
          <InfoWithHeadingDescriptionAndImage
            pictureOnLeftVariant={true}
            headline="Customize for Your Team"
            description="Tailor plans and offerings to suit your organization's unique needs. Create a healthier and happier work environment."
            image={getImageLink(APP_CONSTANTS.BUSINESS_PUBLIC_PAGE_TEAM_IMAGE_TWO)}
          />
        </BusinessPublicPageLayout>
      )}

      <BusinessPublicPageBecomeBusinessPopup
        open={showJoinForm}
        onClose={handleClose}
        formState={formState}
        profileData={profileData}
        handleChange={handleChange}
        setFormState={setFormState}
        onSubmit={handleSubmit}
        getProfileData={getProfileData}
      />
      <PublicAppFooter />
    </>
  )
}

export function BusinessPublicPageBecomeBusinessPopup({
  onSubmit,
  handleChange,
  profileData,
  formState,
  setFormState,
  getProfileData,
  ...rest
}) {
  // const enableEmail = profileData?.email !== undefined && profileData?.email !== ''
  const { unSecureSetupData } = useContext(UnsecureSetupContext)
  const [clicked, setClicked] = useState(false)
  const [showEmailNotVerified, setShowEmailNotVerified] = useState(false)
  const [verifyingEmail, setVerifyingEmail] = useState(false)
  const emailValid = validateEmail(formState?.email)
  const disableJoinBusinessButton = useMemo(() => {
    if (profileData?.emailVerified) {
      return true
    }
    return false
  }, [clicked, profileData])

  async function verifyEmail() {
    setVerifyingEmail(true)
    await getProfileData(setShowEmailNotVerified)
    setVerifyingEmail(false)
  }

  function changeCountry(selectValue) {
    setFormState((prev) => ({
      ...prev,
      location: { ...prev?.location, countryCode: selectValue?.id, country: selectValue?.name },
    }))
  }

  useEffect(() => {
    if (profileData?.emailVerified) {
      setClicked(false)
    }
  }, [profileData])

  return (
    <Dialog PaperComponent={StyledDialogPaper} {...rest}>
      <StyledDialogTitle>Get AUMHUM for Workplace</StyledDialogTitle>
      <MentorJoinModalContent>
        <MentorOnboardingFormComponent id="join-mentor-form" onSubmit={onSubmit}>
          <CustomInput
            id="firstName"
            type="text"
            label="Name"
            value={formState?.firstName}
            onChange={handleChange}
            required
          />
          <div className="d-flex justify-content-stretch align-items-center">
            <CustomInput
              id="email"
              type="email"
              label="Email"
              invalid={!emailValid}
              invalidMessage={formState?.email && 'Your email address is in the wrong format.'}
              valid={profileData?.emailVerified && emailValid}
              disabled={profileData?.emailVerified && !emailValid}
              value={formState?.email}
              onChange={handleChange}
              inputAndMessageContainer={StyledMentorEmailInputAndMessageContainer}
              required
            />
          </div>
          {!profileData?.emailVerified && emailValid && (
            <InvalidMessage
              profileData={profileData}
              formState={formState}
              clicked={clicked}
              getProfileData={getProfileData}
              setClicked={setClicked}
              emailValid={emailValid}
              setShowEmailNotVerified={setShowEmailNotVerified}
            />
          )}
          <CustomSelect
            id="countries"
            label="Location"
            options={unSecureSetupData?.metaCountries}
            getOptionValue={(option) => option?.id}
            getOptionLabel={(option) => option?.name}
            placeholder="Enter your country...."
            menuPortalTarget={document.body}
            styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999, fontFamily: 'Outfit' }) }}
            disabled={emailValid}
            value={formState?.location?.countryCode}
            selectType={selectTypes?.string}
            onChange={changeCountry}
            required
          />
          <CustomCheckBox
            id="terms"
            label={
              <span>
                By checking this box, I agree to AUMHUM&apos;s{' '}
                <StyledMentorJoinVerifyLink
                  underline="always"
                  href={APP_CONSTANTS.APP_TERMS_URL}
                  target="_blank"
                >
                  Terms of Service
                </StyledMentorJoinVerifyLink>{' '}
                and{' '}
                <StyledMentorJoinVerifyLink
                  underline="always"
                  href={APP_CONSTANTS.APP_PRIVACY_POLICY_URL}
                  target="_blank"
                >
                  Privacy Policy
                </StyledMentorJoinVerifyLink>
                .
              </span>
            }
            checked={formState?.terms}
            onChange={handleChange}
            required
            sx={{
              '&.Mui-checked': {
                color: '#6977df',
              },
            }}
          />
        </MentorOnboardingFormComponent>
      </MentorJoinModalContent>
      <StyledDialogActions>
        {clicked && !profileData?.emailVerified && (
          <StyledDialogSingleAction>
            <StyledDialogVerifiedButton
              disabled={!formState?.terms || verifyingEmail}
              onClick={verifyEmail}
            >
              I have verified my email.
            </StyledDialogVerifiedButton>
            {showEmailNotVerified &&
              (verifyingEmail ? (
                <StyledEmailNotVerifiedMessage verifyEmail={verifyingEmail}>
                  Verifying...
                </StyledEmailNotVerifiedMessage>
              ) : (
                <StyledEmailNotVerifiedMessage>
                  You need to verify your email before proceeding!
                </StyledEmailNotVerifiedMessage>
              ))}
          </StyledDialogSingleAction>
        )}
        {!clicked && (
          <StyledDialogJoinButton
            form="join-mentor-form"
            disabled={!disableJoinBusinessButton}
            type="submit"
          >
            Get AUMHUM for Workplace
          </StyledDialogJoinButton>
        )}
      </StyledDialogActions>
    </Dialog>
  )
}

function InvalidMessage({
  profileData,
  formState,
  emailValid,
  getProfileData,
  clicked,
  setClicked,
  setShowEmailNotVerified,
}) {
  const [sending, setSending] = useState(false)
  const [savingText, setSavingText] = useState('Sending...')
  async function handleClickVerify() {
    setShowEmailNotVerified(false)
    setSending(true)
    if (emailValid) {
      if (!profileData?.email) {
        setSavingText('Updating email...')
        const response = await postMPDataWithoutParams('/api/secure/user/update?languageCode', {
          ...profileData,
          email: formState?.email,
        })
        if (response.status === 200) {
          await getProfileData()
          setSavingText('Sending email...')
        }
      }
      // profileData?.email
      // fire validation api email
      const response = await getMPDataWithoutParams(
        `/api/user/${profileData?.userId}/email/verify/resend`,
      )
      if (response.status) {
        setClicked(true)
      }
    }
    setSending(false)
  }
  return (
    <>
      {sending ? (
        <div>{savingText}</div>
      ) : (
        <>
          {clicked ? (
            <StyledMentorJoinVerifyLinkAfter>
              Verification email sent, please check your inbox. To resend,{' '}
              <StyledMentorJoinVerifyLink onClick={handleClickVerify}>
                click here
              </StyledMentorJoinVerifyLink>
            </StyledMentorJoinVerifyLinkAfter>
          ) : (
            <StyledMentorJoinVerifyLink onClick={clicked ? () => {} : handleClickVerify}>
              Click here to verify your email and continue.
            </StyledMentorJoinVerifyLink>
          )}
        </>
      )}
    </>
  )
}
